<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadCallbackGroups(1, null, true)">

      <template slot="actions">
        <vs-input type="number" :placeholder="$t('callback_group.filter.callback_group_no')" v-model="callbackGroupFormData.group" class="configuration-inbound-callback-group" />
        <vx-input-group>
          <vs-input :placeholder="$t('callback_group.filter.name')" v-model="callbackGroupFormData.name" class="configuration-inbound-callback-group-name" />
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button id="addConfigurationCallbackGroupsButton" color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="addCallbackGroup">{{ $t('callback_group.button.add_callback_group') }}</vs-button>
            </div>
          </template>
        </vx-input-group>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input type="number" :placeholder="$t('callback_group.filter.callback_group_no')" v-model="callbackGroupSearchParams.group" class="w-full mb-3"/>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('callback_group.filter.name')" v-model="callbackGroupSearchParams.name" class="w-full"/>
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadCallbackGroups(1, null, true)" v-text="$t('search')"></vs-button>
      </template>

    </vx-card>

    <vx-card id="callbackGroupDataContainer" :title="$t('callback_group')" class="mb-8 vs-con-loading__container">

      <template slot="actions">
        <shared-configuration-tab-nav></shared-configuration-tab-nav>
      </template>

      <shared-user-configuration-inbound-callback-group-list
        :callbackGroups="callbackGroups"
        @customClickEdit="edit"
        @customClickDelete="destroy"
        @customClickSave="save"
        @customClickCancel="cancel"
      ></shared-user-configuration-inbound-callback-group-list>

      <template slot="footer">
        <paginate
          :total="callbackGroupPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadCallbackGroups"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>

    </vx-card>
  </div>
</template>

<script>
import SharedConfigurationTabNav from '@/views/Shared/Configuration/TabNav'
import CallbackGroup from '@/models/CallbackGroup'
import SharedUserConfigurationInboundCallbackGroupList from '@/views/Shared/Configuration/Inbound/CallbackGroups/List'
import Paginate from '@/mixins/paginate'

export default {
  name: 'User.Configuration.Inbound.CallbackGroup',
  mixins: [Paginate],
  components: {
    SharedConfigurationTabNav,
    SharedUserConfigurationInboundCallbackGroupList
  },
  data () {
    return {
      callbackGroupsEdit: {},
      callbackGroups: {},
      callbackGroupPages: 1,
      callbackGroupFormData: {
        company_id: '',
        name: '',
        group: '',
        id: ''
      },
      callbackGroupFormErrors: {},
      itemPerPage: null,
      callbackGroupSearchParams: {
        group: typeof this.$route.query.group !== 'undefined' ? this.$route.query.group : '',
        name: typeof this.$route.query.name !== 'undefined' ? this.$route.query.name : ''
      }
    }
  },
  mounted () {
    this.loadCallbackGroups(this.initialPage, null, false, true)
  },
  methods: {
    async loadCallbackGroups (page = 1, itemPerPage = null, backToPageOne = false, isOnLoad = false) {
      this.$vs.loading({container: '#callbackGroupDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      if (!isOnLoad) {
        this.$router.replace({query: { ...this.callbackGroupSearchParams, page, itemPerPage }})
      }
      const response = await CallbackGroup.all({ ...this.callbackGroupSearchParams, page, itemPerPage })
      this.callbackGroups = response.data.data.callbackGroups
      this.callbackGroupPages = response.data.meta.pagination.last_page
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#callbackGroupDataContainer > .con-vs-loading')
    },
    async addCallbackGroup (e) {
      e.preventDefault()
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addConfigurationCallbackGroupsButton', scale: 0.45})
      if (this.callbackGroupFormData.group.trim().length === 0 && this.callbackGroupFormData.name.trim().length === 0) {

        await this.$swalHelper.error({
          title: '',
          text: this.$t('add_ring_group_error_message_if_empty_ring_group_and_empty_name'),
          confirmButton: this.$t('confirm')
        })

      } else if (this.callbackGroupFormData.group.trim().length === 0) {

        await this.$swalHelper.error({
          title: '',
          text: this.$t('add_ring_group_error_message_if_empty_ring_group'),
          confirmButton: this.$t('confirm')
        })

      } else if (this.callbackGroupFormData.name.trim().length === 0) {

        await this.$swalHelper.error({
          title: '',
          text: this.$t('add_ring_group_error_message_if_empty_name'),
          confirmButton: this.$t('confirm')
        })

      } else if (!this.$store.getters.isFormInProgress) {
        this.$store.dispatch('setIsFormInProgress', true)
        await CallbackGroup.store(this.callbackGroupFormData)
        this.$store.dispatch('setIsFormInProgress', false)
        this.loadCallbackGroups(1, this.itemPerPage)
        this.callbackGroupFormData = {
          company_id: '',
          name: '',
          group: '',
          id: ''
        }
        this.callbackGroupFormErrors = {}
      }
      this.$vs.loading.close('#addConfigurationCallbackGroupsButton > .con-vs-loading')
    },
    async edit (key) {
      this.callbackGroups[key].edit = true
      const editElem = this.callbackGroups[key]
      const editObj = {
        name: editElem.name,
        group: editElem.group
      }
      this.callbackGroupsEdit[key] = editObj
    },
    async cancel (key) {
      this.callbackGroups[key].name = this.callbackGroupsEdit[key].name
      this.callbackGroups[key].group = this.callbackGroupsEdit[key].group
      this.callbackGroups[key].edit = false
      this.callbackGroups[key].callbackGroupFormErrors = {}
      delete this.callbackGroupsEdit[key]
    },
    async save (key, id) {
      this.$vs.loading({background: 'primary', color: '#fff', container: `#updateConfigurationCallbackGroupsButton${  id}`, scale: 0.45})
      try {
        await CallbackGroup.update(this.callbackGroups[key])
        this.callbackGroups[key].edit = false
        this.callbackGroups[key].callbackGroupFormErrors = {}
      } catch (e) {
        this.callbackGroups[key].callbackGroupFormErrors = e.response.data.errors
      }
      this.$vs.loading.close(`#updateConfigurationCallbackGroupsButton${  id  } > .con-vs-loading`)
    },
    async destroy (key, id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        await CallbackGroup.destroy({ id })
        this.loadCallbackGroups(1, this.itemPerPage)
      }
    }
  }
}
</script>

<style lang="scss">
  #addConfigurationCallbackGroupsButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
